Object.defineProperty(exports,"__esModule",{value:true});

var _react=require('react');
var _warning=require('warning');var _warning2=_interopRequireDefault(_warning);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var checkIndexBounds=function checkIndexBounds(props){var

index=

props.index,children=props.children;

var childrenCount=_react.Children.count(children);

(0,_warning2.default)(index>=0&&index<=childrenCount,'react-swipeable-view: the new index: '+
index+' is out of bounds: [0-'+childrenCount+'].');

};exports.default=

checkIndexBounds;


//////////////////
// WEBPACK FOOTER
// ./~/react-swipeable-views-core/lib/checkIndexBounds.js
// module id = 725
// module chunks = 0